export const getExtension = (url: string): string => {
  if (!url) return '';
  const parts = url.split('.');
  if (parts.length > 1) {
    return parts.pop()?.toLowerCase() || '';
  }
  return '';
};
